export default __webpack_public_path__ + "static/media/BCA36.97c68605.jpg";